import {
  colorUseCases,
  CSS,
  getColorScaleValueByUseCase,
} from "@vitality-ds/system";

import { getFontFaceSrc } from "../../util/get-font-path";
import { sharedStyles } from "../InlineCode";
import { FONT_FILE_NAMES } from "./constants";

const { backgrounds } = colorUseCases;

export const sidebarWidthVar = "vitality-sidebar-width";
export const TOC_WIDTH = 285;

const styles: Record<string, CSS> = {
  global: {
    pre: {
      // hardcoding because safari makes pre tags "reset" the rem inheritance
      fontSize: 16,
    },
    body: {
      // override user agent stylesheet
      margin: 0,
      background: getColorScaleValueByUseCase("neutral", backgrounds.app),
    },
    code: sharedStyles,
    "@font-face": [
      {
        fontFamily: "ABC Whyte",
        src: getFontFaceSrc(FONT_FILE_NAMES.book),
        fontWeight: 400,
      },
      {
        fontFamily: "ABC Whyte",
        src: getFontFaceSrc(FONT_FILE_NAMES.medium),

        fontWeight: 500,
      },
      {
        fontFamily: "ABC Whyte",
        src: getFontFaceSrc(FONT_FILE_NAMES.bold),
        fontWeight: 600,
      },
      {
        fontFamily: "ABC Whyte",
        src: getFontFaceSrc(FONT_FILE_NAMES.heavy),
        fontWeight: 700,
      },
    ],
  },
};

export default styles;
